import { Common, color } from '@stockbit/ui';

const { IconWrapper, Iconmoon } = Common;

interface ListCloseIconTypes {
  handleOnClickDelete: () => void;
}

const ListCloseIcon = ({ handleOnClickDelete }: ListCloseIconTypes) => (
  <IconWrapper padding="0 5px">
    <Iconmoon
      className="icon-widget_close"
      color={color.sunsetOrange}
      hoverColor={color.sunsetOrange}
      size="14px"
      weight="bold"
      onClick={handleOnClickDelete}
    />
  </IconWrapper>
);

export default ListCloseIcon;
